import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Box, Grid, Typography } from '@mui/material';
import { getDailyCustomer, getRideAnalytic, getRideDetails, getTotalRegistration } from 'redux/actions/UserDashboard';
import { getCabRide,getTopDriver, getTopSubVendor, getTopVendor } from 'redux/actions/UserTopSection';
import ChartComponent from 'components/chartComponent/ChartComponent';
import CommonDateRangePicker from 'pages/date/CommonDateRangePicker';
import DashboardCard from './DashboardCard';
import { dashboardCardData } from './DashboardData';
import "./Dashboard.scss";
import { dateFormate } from 'utils/utils';

function Dashboard() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get('startDate');
  const endDate = searchParams?.get('endDate');
  const role = localStorage.getItem('role')
  const dispatch = useDispatch();
  const [value, setValue] = useState('1');
  const tableData = useSelector((state) => state);
  const totalRegistration = useSelector((state) => state?.userTotalRegistration?.userTotalRegistration?.data) || {}
  const rideAnalytic = useSelector((state) => state?.userRideAnalytic?.userRideAnalytic?.data )|| {}
  const cabRideData = useSelector((state) => state?.userCabRide?.userCabRide?.data);
  const locationData = useSelector((state) => state?.userServiceCity?.userServiceCity?.data);

  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  const [dateFrom, setDateFrom] = useState(
    startDate && startDate !== 'null'
      ? startDate
      : startDate === 'null'
      ? ''
      : dateFormate(thirtyDaysAgo, 'MM/DD/YYYY')
  );
  const [dateTo, setDateTo] = useState(
    endDate && endDate !== 'null'
      ? endDate
      : endDate === 'null'
      ? ''
      : dateFormate(new Date(), "MM/DD/YYYY")
  );

  const Location = locationData
  const [locValue, setLocValue] = useState(Location?.length > 0 ? Location[0] : {});
  const [locId, setLocId] = useState('');
  let filterDateRange = {
    dateFrom:dateFrom,
    dateTo:dateTo,
    location:locId?.toString()
  }

  // const isLoadingTotalRegistration = useSelector(state => state?.userTotalRegistration.loading)
  // const isLoadingRideAnalytic = useSelector(state => state?.userRideAnalytic.loading)
  const dashBorardUpperData = useSelector(
    (state) => state?.userRideDetails?.userRideDetails?.data?.body?.[0]
  );

  useEffect(() => {
    dispatch(getRideAnalytic(filterDateRange));
    dispatch(getRideDetails(filterDateRange));
    dispatch(getTotalRegistration(filterDateRange));
  }, [])
  
  const onSelectDateRange = (newValue) => {
    if(newValue === null || newValue === 0){
      setSearchParams({ startDate: 'null', endDate: 'null' });
      setDateFrom('')
      setDateTo('')
      filterDateRange = {...filterDateRange, 
        dateFrom:'',
        dateTo:''
      }
    }else{
      setSearchParams({startDate: dateFormate(newValue[0], "MM/DD/YYYY"), endDate:dateFormate(newValue[1],"MM/DD/YYYY")})
      setDateFrom(dateFormate(newValue[0],"MM/DD/YYYY"))
      setDateTo(dateFormate(newValue[1],"MM/DD/YYYY"))
      filterDateRange = {...filterDateRange, 
        dateFrom:dateFormate(newValue[0],"MM/DD/YYYY"),
        dateTo:dateFormate(newValue[1],"MM/DD/YYYY")
      }
    }
    dispatch(getRideDetails(filterDateRange));
    dispatch(getTotalRegistration(filterDateRange));
    dispatch(getRideAnalytic(filterDateRange));
  }

  return (
   <Box>
    <Grid container 
    alignItems="center" 
    justifyContent="flex-end" 
    className='mb30'>
      <CommonDateRangePicker onSelectDateRange={onSelectDateRange} dateFrom={dateFrom} dateTo={dateTo}/>
    </Grid>
     <DashboardCard
        cardData={dashboardCardData(dashBorardUpperData)}
        dateFrom={dateFrom}
        dateTo={dateTo}
        locValue={locValue}
      />
        <Box className="mb25">
          <Typography className='mb20 fw600'>Graph and Analytics</Typography>
        <ChartComponent tableData={tableData} />
      </Box>
   
   </Box>
  );
}

export default Dashboard;
